<ng-container *ngFor="let item of data">
  <div *ngIf="!item.dismissed && item.channel != hideByChannel" class="alert alert-{{item.type}} fade show" [ngClass]="{'alert-dismissible': item.dismissable}" role="alert">
    <h3 class="alert-heading" [innerHTML]="item.title | translate"></h3>
    <p [innerHTML]="item.message"></p>
    <button *ngIf="item.dismissable" type="button" class="btn btn-white btn-xs" (click)="dismiss(item);"><i class="fas fa-eye-slash mr-2"></i>Nascondi annuncio</button>
  </div>
</ng-container>
